module.exports = __webpack_public_path__ + "img/sb_march83_p3.38f47b35.jpg";